import { Dialog } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import useTranslation from 'customHooks/translate';

interface IProps {
  open: boolean;
  handleClose?: () => void;
  title: string;
  children: React.ReactNode;
}

const TableDialog = ({ open, children, handleClose, title }: IProps) => {
  const translation = useTranslation();

  return (
    <Dialog open={open} onClose={handleClose} className="custom-dialog ">
      <div className="flex flex-col gap-[20px]">
        <div className="mb-[10px] flex items-baseline justify-between gap-[10px]">
          <p className="text-[20px] font-medium text-[#1D1D1D] md:text-[24px]">
            {title} - {translation.allInfo}
          </p>
          {handleClose ? (
            <div className="flex items-center justify-end">
              <div
                className="flex h-[24px] w-[24px] cursor-pointer items-center justify-center rounded-[4px] border border-[#292D32]"
                onClick={handleClose}
              >
                <CloseIcon className="close-icon" />
              </div>
            </div>
          ) : null}
        </div>
        {children}
        <button
          onClick={handleClose}
          type="submit"
          className="w-full rounded-[8px] bg-[#6dcd90] px-[24px] py-[12px] text-[14px] font-normal leading-[16px] text-white md:text-[16px]"
        >
          {translation.close}
        </button>
      </div>
    </Dialog>
  );
};

export default TableDialog;
